import React, { useState } from "react";
import { MapRef } from "react-map-gl";

import { LyrsTypes } from "./map";

import { Checkbox } from "@components/common/checkbox";

interface LegendProps {
  mapRef: any;
  layersInformation: LyrsTypes[];
  setLayerId: React.Dispatch<React.SetStateAction<string | undefined>>;
  setActiveLayers: React.Dispatch<React.SetStateAction<string[] | undefined>>;
}
const Legend: React.FunctionComponent<LegendProps> = ({
  mapRef,
  layersInformation,
  setLayerId,
  setActiveLayers,
}) => {
  const [selLayer, setSelLayer] = useState<string[]>([]);

  const onLayerChange = (e: any) => {
    let _layers = [...selLayer];
    setLayerId(e.value);
    if (e.checked) _layers.push(e.value);
    else _layers.splice(_layers.indexOf(e.value), 1);
    setActiveLayers(_layers);
    setSelLayer(_layers);
  };

  React.useEffect(() => {
    if (layersInformation) {
      const layers = layersInformation.map((x) => x.layerName);
      setSelLayer(layers);
    }
  }, [layersInformation, mapRef.current]);

  React.useEffect(() => {
    // console.log(layersInformation)
    // console.log('how many times this component being rendered')
  }, [layersInformation]);
  return (
    <>
      <div className="legend">
        {layersInformation?.slice(0, 6).map((r, i) => (
          <div key={i} className="legend-item">
            <Checkbox
              className="checkbox"
              id={r.layerName}
              name="lyrs"
              value={r.layerName}
              onChange={onLayerChange}
              checked={selLayer.includes(r.layerName)}
            />
            {r.geomType === "Point" ? (
              <img
                alt=""
                src={`${process.env.PUBLIC_URL}/${r?.customstyle?.layout["icon-image"]}.png`}
              />
            ) : (
              <span
                className="legend-color"
                style={{ backgroundColor: r?.customstyle.paint["line-color"] }}
              />
            )}
            <span className="legend-label">
              {r.layerName === "מתאם" ? "חיבור לבית" : r.layerName}
            </span>
          </div>
        ))}
      </div>
    </>
  );
};

export default Legend;
